import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './edit';
import Save from './save';

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: '#0061FE',
    src: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
      >
        <rect x="2" y="7" width="8" height="12" rx="1" />
        <rect x="13" y="10" width="8" height="12" rx="1" opacity=".55" />
        <circle cx="6" cy="4.5" r="2" />
        <circle cx="17" cy="7.5" r="2" opacity=".55" />
      </svg>
    ),
  },
});
